<template>
    <PageContainer>
        <Breadcrumbs :breadcrumbs="breadcrumbs" />

        <div class="relative mx-auto my-8">
            <Input
                :focused="focused"
                class="input search-input"
                placeholder="Search for something..."
                :value="query"
                @input="searchDebounced"
            />
            <SearchIcon
                v-show="!isLoading"
                class="icon"
            />
            <Spinner
                v-show="isLoading"
                :line-size="2"
                size="18"
                class="icon"
            />
        </div>
        <div class="flex flex-wrap -mx-4">
            <div
                v-for="(product, index) in products"
                :key="index"
                class="w-1/2 lg:w-1/3 px-4 mb-8"
            >
                <ProductCard
                    :product="product"
                    :position="index"
                    list="Search"
                    class=""
                />
            </div>
        </div>
        <div class="flex justify-center">
            <Button
                v-if="isLoadMoreButtonShown"
                :loading="isLoadMoreProductsLoading"
                :disabled="isLoadMoreProductsLoading"
                text="Load More Products"
                bg="2025-dark-pink"
                @click="loadMoreProducts"
            />
        </div>
    </PageContainer>
</template>

<script>
import debounce from 'debounce';
import Breadcrumbs from '~/components/Breadcrumbs';
import Spinner from '~/components/Spinner';
import Input from '~/components/Input';
import SearchIcon from '~/static/fonts/LineIcons/magnifier.svg';
import ProductCard from '~/components/ProductCard';
import Button from '~/components/Button';
import PageContainer from '@/components/PageContainer.vue';

export default {

    components: {
        PageContainer,
        Breadcrumbs,
        Spinner,
        Input,
        SearchIcon,
        ProductCard,
        Button,
    },

    data() {
        return {

            successMessage: '',
            breadcrumbs: [
                {
                    name: 'Home',
                    link: '/',
                },
                {
                    name: 'Search',
                    link: '',
                },
            ],
            query: this.$route.query.query,
            isLoading: false,
            products: [],
            pageNumber: 1,
            pageLength: 21,
            focused: false,
            isLoadMoreButtonShown: true,
            isLoadMoreProductsLoading: false,
            controller: null,
        };
    },

    created() {
        const param = this.$route.query;
        const { query } = param;
        this.search(query);
    },

    methods: {
        searchDebounced: debounce(function _(query) {
            // Abort any requests in progress
            if (this.controller) {
                this.controller.abort();
            }

            this.controller = new AbortController();

            const searchQuery = query.trim();
            this.pageNumber = 1;
            this.products = [];

            this.addPageNumberToQueryString();
            if (searchQuery.length) {
                this.isLoading = true;
                const self = this;

                this.$axios.$get('/search', {
                    signal: this.controller.signal,
                    params: {
                        query: searchQuery,
                        per_page: this.pageLength,
                        page: this.pageNumber,
                    },
                })
                    .then((results) => {
                        self.products = [...self.products, ...results.products.items];
                        self.isLoadMoreButtonShown = self.products.length >= self.pageLength;
                    })
                    .catch((error) => {
                        // Do nothing
                    })
                    .finally(() => {
                        self.isLoading = false;
                    });
            }
        }, 250),
        focusInput() {
            this.focused = false;
            this.$nextTick(() => {
                this.focused = true;
            });
        },
        async search(query) {
            this.addPageNumberToQueryString();
            const results = await this.$axios.$get(`/search?query=${query}&per_page=${this.pageLength}&page=${this.pageNumber}`);
            this.products = [...this.products, ...results.products.items];
        },
        async loadMoreProducts() {
            this.isLoadMoreProductsLoading = true;
            this.pageNumber += 1;
            this.addPageNumberToQueryString();
            this.isLoadMoreProductsLoading = false;
            await this.fetchSearch(true);
        },
        async fetchSearch(shouldPush = false) {
            const param = this.$route.query;
            const { query } = param;
            const results = await this.$axios.$get(`/search?query=${query}&per_page=${this.pageLength}&page=${this.pageNumber}`);
            this.products = [...this.products, ...results.products.items];
            this.isLoadMoreButtonShown = true;
            this.isLoadMoreButtonShown = results.products.items.length >= this.pageLength;
        },
        addPageNumberToQueryString() {
            this.$router.push({
                path: this.$router.currentRoute.path,
                query: {
                    query: this.query,
                    per_page: this.pageLength,
                    page: this.pageNumber,
                },
            });
        },
    },

};
</script>

<style lang="scss" scoped>
.heading {
    @apply font-heading text-primary;
    font-size: 300%;
}

a {
    @apply text-primary transition-fast no-underline;

    &:hover {
        @apply opacity-75;
    }
}

.input {
    width: 100%;
}

.icon {
    height: 18px;
    right: 4px;
    top: 50%;
    transform: translateY(-50%);
    @apply absolute pointer-events-none mr-2;
}
</style>
